import React from 'react';
import useCurrentGroup from '../../../../../hooks/useCurrentGroup';
import { Box, BoxProps } from '@wegroup/design-system';

const QuestionGroupBody: React.FC<React.PropsWithChildren<BoxProps>> = ({
  children,
  ...otherProps
}) => {
  const currentGroup = useCurrentGroup();
  if (!currentGroup) return <></>;
  return (
    <Box
      flexGrow={1}
      py={{ base: '2', tabletS: '4', laptop: '8' }}
      pb={{ base: '4', laptop: '8' }}
      px={{ base: '3', laptop: '8' }}
      {...otherProps}
    >
      {children}
    </Box>
  );
};

export default QuestionGroupBody;
